import { AuthenticatedRequest, HTTPMethod, APIVersion, BasicRequest, APIError } from "../requests/request";
import { DataSource, SubAccount } from '../models';

export interface SubPage {
    name: string;
    id: string
}

export class API {

    public static getSubAccounts(datasource: DataSource): Promise<SubAccount[]> {
        let apiRequest = new AuthenticatedRequest<SubAccount[]>('/datasource/' + datasource.id + '/subAccounts', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static setClientDatasource(datasource: DataSource, page_id: string, client: SubAccount): Promise<SubAccount> {
        let apiRequest = new AuthenticatedRequest<SubAccount>('/clients/' + client.id + '/datasources/' + datasource.id + '/' + page_id, HTTPMethod.PUT, APIVersion.v1_0);

        return apiRequest.send(SubAccount).then((response) => {
            return response.data;
        });
    }

}


// WEBPACK FOOTER //
// ./src/api/endpoints/datasources.ts